<template>
  <section>
    <b-modal
      id="modalReportSuccess"
      centered
      hide-footer
      hide-header
      hide-actions>
      <section class="c-modal-lection">
        <div
          class="c-modal-lection__dialog"
        >
          <section
            class="c-success-message w-100 h-100 p-3 p-lg-4 visible">
            <div class="d-flex flex-column justify-content-center align-items-center h-100">
              <h3 class="darks w-bold fs-25">Reporte enviado</h3>
              <p class="mb-4 mb-md-5 fs-18 w-medium">
                Hemos recibido tu reporte, lo revisaremos y te responderemos a tu correo:
                <span class="fs-18 w-sbold darks">{{ user.email }}</span>
              </p>
              <figure class="c-success-message__vector mb-5">
                <img
                  class="w-100 h-100 of--contain"
                  src="../../../assets/images/lection/report/success.png" alt=""
                />
              </figure>
              <p class="mb-0">
                Si necesitas ayuda adicional puedes escribirnos a:
                <a :href="'mailto:' + supportEmail" class="c-link">{{ supportEmail }}</a>
              </p>
            </div>
          </section>
        </div>
      </section>
    </b-modal>

    <b-modal
      id="modalReport"
      centered
      hide-footer
      hide-header
      hide-actions
      no-close-on-backdrop>
      <section class="c-modal-lection">
        <div
          class="c-modal-lection__dialog"
        >
          <header class="c-banner position-relative overflow-hidden">
            <figure class="c-banner__image">
              <img
                class="w-100 h-100 of--cover"
                src="../../../assets/images/lection/report/banner.png" alt="" srcset=""
              />
            </figure>
            <div class="c-banner__body position-absolute white w-100 h-100">
              <h3 class="fs-25 w-bold mb-2 text-center">Reportar un problema</h3>
              <p class="mb-0 fs-18 w-medium text-center">Cuéntanos un poco más de lo ocurrido</p>
            </div>
          </header>
          <section class="p-3 p-lg-4">
            <form class="c-form c-form--ghost mb-4">
              <div class="row">
                <div class="col col-12">
                  <p class="c-form__label mb-1">Detalla tu reporte</p>
                  <div class="c-form__block">
                    <div class="mb-3">
                      <ul class="ul-reset">
                        <li
                          class="mb-1"
                        >
                          Usuario:
                          <span class="darks w-sbold">
                            {{ user.first_name }} {{ user.last_name }}
                          </span>
                        </li>
                        <li v-if="report.module" class="mb-1">
                          {{ (report.type == 'lection') ? 'Modulo' : 'Curso' }}:
                          <span class="darks w-sbold">
                            {{ (report.type == 'exam') ? course : report.module }}
                          </span>
                        </li>
                        <li v-if="report.lection" class="">
                          {{(report.type == 'lection') ? 'Clase' : 'Pregunta'}}:
                          <span class="darks w-sbold">{{ report.lection }}</span>
                        </li>
                      </ul>
                    </div>
                    <textarea
                      class="c-form__textarea w-100"
                      :placeholder="placeholder"
                      v-model="comment"
                    >
                    </textarea>
                  </div>
                </div>
              </div>
            </form>
            <div class="d-flex aligm-items-center justify-content-end">
              <button class="c-link c-link--black" @click="closeReportModal">Cancelar</button>
              <button
                class="c-button c-button--primary ms-3"
                :disabled="(comment.length > 3 && !isLoading) ? false : true"
                :class="{ loading : isLoading }"
                @click="sendReport">
                {{ (isLoading) ? 'Enviando...' : 'Enviar reporte' }}
                <img
                  class="c-button__spinner"
                  src="../../../assets/images/animations/spinner-white.png" alt="loading"
                />
              </button>
            </div>
          </section>
        </div>
      </section>
    </b-modal>
  </section>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex';

export default {
  data() {
    return {
      supportEmail: window.arcux.project.support_email,
      isLoading: false,
      isSent: false,
      comment: '',
      placeholder: 'Ejemplo: Pasé a la siguiente clase y el video se quedó en la pantalla de carga...',
    }
  },
  mounted() {
  },
  props: ['user', 'course'],
  computed: {
    ...mapState({
      report: state => state.modals.report,
    }),
  },
  watch: {
    'isSent': function(value) {
      if (value) {
        this.$bvModal.show('modalReportSuccess');

        window.setTimeout(() => {
          this.isSent = false;
        }, 4000)
      } else {
        this.$bvModal.hide('modalReportSuccess');
      }
    },
  },
  methods: {
    closeReportModal: function() {
      this.$bvModal.hide('modalReport');
    },
    sendReport: function() {
      /* TODO: API */
      this.isLoading = true;

      const courseId  = this.$route.params.course_id;
      let formData    = new FormData();

      formData.append('userId', this.user.id);
      formData.append('courseId', courseId);
      formData.append('message', this.comment);
      formData.append('type', this.report.type);

      if (this.report.type == 'lection') {
        formData.append('content', JSON.stringify({
          course: this.course,
          module: this.report.module,
          lesson: this.report.lection,
          url: window.arcux.site + '/panel' + this.$route.path,
        }));
      } else if (this.report.type == 'exam') {
        formData.append('content', JSON.stringify({
          course: this.course,
          question: this.report.lection,
          url: window.arcux.site + '/panel' + this.$route.path,
        }));
      } else if (this.report.type == 'resources') {
        formData.append('content', JSON.stringify({
          course: this.course,
          url: window.arcux.site + '/panel' + this.$route.path,
        }));
      } else {
        formData.append('content', JSON.stringify({
          course: this.course,
          url: window.arcux.site + '/panel' + this.$route.path,
        }));
      }

      const requestURL = `${window.arcux.site}/api/v1/courses/${courseId}/incidents/`;

      fetch(requestURL, {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
      .then(res => {
        if (res.status == 201 || res.status < 300) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then(data => {
        this.isLoading = false;
        this.isSent = true;
        this.comment = '';

        this.closeReportModal();

        setTimeout(() => {
          this.isSent = false;
        }, 4000);
      })
      .catch(err => {
        throw err;
      })
    },
  },
}
</script>
